import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "./TileInfo.js";
var r = {
  type: e,
  json: {
    origins: {
      service: {
        read: {
          source: ["tileInfo", "minScale", "maxScale", "minLOD", "maxLOD"],
          reader: n
        }
      }
    }
  }
};

function n(r, n, l, o) {
  if (!r) return null;
  var i = n.minScale,
      t = n.maxScale,
      m = n.minLOD,
      s = n.maxLOD;
  if (null != m && null != s) return o && o.ignoreMinMaxLOD ? e.fromJSON(r) : e.fromJSON(_objectSpread(_objectSpread({}, r), {}, {
    lods: r.lods.filter(function (_ref) {
      var e = _ref.level;
      return null != e && e >= m && e <= s;
    })
  }));

  if (0 !== i && 0 !== t) {
    var _n = function _n(e) {
      return Math.round(1e4 * e) / 1e4;
    },
        _l = i ? _n(i) : 1 / 0,
        _o = t ? _n(t) : -1 / 0;

    return e.fromJSON(_objectSpread(_objectSpread({}, r), {}, {
      lods: r.lods.filter(function (e) {
        var r = _n(e.scale);

        return r <= _l && r >= _o;
      })
    }));
  }

  return e.fromJSON(r);
}

export { n as readServiceTileInfo, r as serviceTileInfoProperty };